"use strict";
/*
 * Created on 10 05 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ValidationResultConverter_1 = require("../../core/model/errors/conversions/ValidationResultConverter");

var ValidationResult_1 = require("../../core/model/errors/ValidationResult");

var PriceFormulas_1 = require("../../core/model/math/PriceFormulas");

var utils_1 = require("../../core/utils");

var CompanyVsCRPChangeIndex_1 = require("../model/CompanyVsCRPChangeIndex");

var CompanyVsCRPChangeIndexConverter_1 = require("./CompanyVsCRPChangeIndexConverter");
/**
 * @author Radek Beran
 */


var CompanyVsCRPChangeIndexConverterImpl =
/*#__PURE__*/
function (_CompanyVsCRPChangeIn) {
  _inherits(CompanyVsCRPChangeIndexConverterImpl, _CompanyVsCRPChangeIn);

  function CompanyVsCRPChangeIndexConverterImpl(validationResultConverter) {
    var _this;

    _classCallCheck(this, CompanyVsCRPChangeIndexConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CompanyVsCRPChangeIndexConverterImpl).call(this));
    _this.validationResultConverter = validationResultConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(CompanyVsCRPChangeIndexConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new CompanyVsCRPChangeIndex_1.CompanyVsCRPChangeIndex(CompanyVsCRPChangeIndex_1.CompanyVsCRPChangeIndex.schema.value.valueOf(conversions.toBigNumber(source.value)), utils_1.Utils.isValueMissing(source.crpValue) ? PriceFormulas_1.PriceFormulas.ZERO // temporary fallback for backward compatibility, can be removed in production
      : CompanyVsCRPChangeIndex_1.CompanyVsCRPChangeIndex.schema.crpValue.valueOf(conversions.toBigNumber(source.crpValue)), CompanyVsCRPChangeIndex_1.CompanyVsCRPChangeIndex.schema.competitorId.valueOf(conversions.toClassReferenceId(source.competitorId)), utils_1.Utils.isValueMissing(source.validationResult) ? ValidationResult_1.ValidationResult.EMPTY : this.validationResultConverter.toObject(source.validationResult, conversions));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        value: conversions.fromBigNumber(source.value),
        crpValue: conversions.fromBigNumber(source.crpValue),
        competitorId: conversions.toDocumentReferenceId(source.competitorId),
        validationResult: this.validationResultConverter.toDocument(source.validationResult, conversions)
      });
      return result;
    }
  }]);

  return CompanyVsCRPChangeIndexConverterImpl;
}(CompanyVsCRPChangeIndexConverter_1.CompanyVsCRPChangeIndexConverter);

CompanyVsCRPChangeIndexConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [ValidationResultConverter_1.ValidationResultConverter])], CompanyVsCRPChangeIndexConverterImpl);
exports.CompanyVsCRPChangeIndexConverterImpl = CompanyVsCRPChangeIndexConverterImpl;